import layouts, { layoutVariants, layoutVariantsType } from './layout';
import colors, { colorVariants, colorVariantsType } from './color';

export const logoSectionVariants = {
  layouts: layoutVariants,
  colors: colorVariants
};

export interface LogoSectionVariantsType {
  /** The LogoSection types. */
  Layouts: layoutVariantsType;
  Colors: colorVariantsType
}

const logoSection = {
  layouts,
  colors
};

export default logoSection;
